import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Layout from '../components/Layout.vue'
import PartnerUser from '../components/PartnerUser.vue'
import Customer from '../components/Customer.vue'
import Gateway from '../components/Gateway.vue'
import Trigger from '../components/Trigger.vue'
import Device from '../components/Device.vue'
import Shipping from '../components/Shipping.vue'
import Preference from '../components/Preference.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    meta: {
      authRequired: true
    },
    children: [
      {
        path: 'partnerUser',
        name: 'partnerUser',
        component: PartnerUser,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'customer',
        name: 'customer',
        component: Customer,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'gateway',
        name: 'gateway',
        component: Gateway,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'trigger',
        name: 'trigger',
        component: Trigger,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'device',
        name: 'device',
        component: Device,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'shipping',
        name: 'shipping',
        component: Shipping,
        meta: {
          role: 'partnerUser'
        }
      },
      {
        path: 'preference',
        name: 'preference',
        component: Preference,
        meta: {
          role: 'partnerUser'
        }
      },
      { path: '', redirect: '/customer' }
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  { path: '*', redirect: '/customer' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  let partnerUser = localStorage.getItem('partnerUser');
  if (authRequired && !partnerUser) {
    return next('/login');
  }
  partnerUser = JSON.parse(partnerUser)
  return next();
})


export default router
